import axios from 'axios'
import jwt from '@/helpers/jwtHelper'

function configCore(config) {
  config.headers['AUTHORIZATION'] = `Bearer ${jwt.token}`
  return config
}

function handleError(err) {
  return Promise.reject(err)
}

export const core = axios.create({ baseURL: `${process.env.VUE_APP_CORE_API}` })
core.interceptors.request.use(configCore, handleError)
